import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ClassroomFilterDto } from '../../../../../data/models/dto/classroom-filter.dto';
import { UserDetailsDto } from '../../../../../data/models/dto/user-details.dto';
import { UserParamsDto } from '../../../../../data/models/dto/user-params.dto';
import { Gate } from '../../../../../data/models/interfaces/arrival/gate.interface';
import { User } from '../../../../../data/models/interfaces/user.interface';
import { GateService } from '../../../../../data/services/arrival/gate.service';
import { UsersService } from '../../../../../data/services/user.service';
import { confirmationBottomSheet } from '../../../../../data/utils/bottom-sheet-confirmation.utils';
import { UserUtil } from '../../../../../data/utils/user.utils';
import { CustomSnackbarService } from '../../../../../ui/components/custom-snackbar/custom-snackbar-service';
import { SimpleNode } from 'src/app/ui/components/select-hierarquical-list/model/simple.node.interface';
import { ImageItem } from '../../../../../ui/components/select-simple-list/model/item-image.interface';
import { GateFormComponent } from '../gate-form/gate-form.component';
import { ClassRoomsService } from '../../../../../data/services/classroom.service';
import { GateFilterDto } from '../../../../../data/models/dto/arrival/gate-filter.dto';
import { SimpleUserDto } from 'src/app/data/models/dto/simple-user.dto';

@Component({
  selector: 'app-gate-list',
  templateUrl: './gate-list.component.html',
  styleUrls: ['./gate-list.component.scss'],
})
export class GateListComponent implements OnInit {
  get user() {
    return this.userUtil.getUser();
  }

  get schools() {
    return this.userUtil.getSchools();
  }

  get canEdit() {
    return this.userUtil.canEditGates();
  }

  gates: Gate[] = [];
  segmentTree: SimpleNode[] | undefined;
  responsableList: ImageItem[] = [];

  constructor(
    private userService: UsersService,
    private userUtil: UserUtil,
    private gateService: GateService,
    private dialog: MatDialog,
    private snackbar: CustomSnackbarService,
    private classroomsServive: ClassRoomsService,
    private bottomSheet: MatBottomSheet,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getAll();
    this.loadSegmentTree();
    this.loadResponsableList();
  }

  private async getAll(): Promise<void> {
    const filter: GateFilterDto = {
      idSchool: this.schools[0].id,
    };

    await this.gateService
      .getAll(filter)
      .toPromise()
      .then(
        (resp: Gate[]) => {
          this.gates = resp;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  private async loadSegmentTree(): Promise<void> {
    const filter: ClassroomFilterDto = {
      idSchool: this.schools[0].id,
      year: new Date().getFullYear().toString(),
    };
    const tree = await this.classroomsServive.getTree(filter).toPromise();
    this.segmentTree = tree.map((seg) => ({
      id: seg.id,
      name: seg.name,
      children: seg.series.map((ser) => ({
        name: ser.name,
        children: ser.classRooms.map((cls) => ({
          id: cls.id,
          name: cls.name,
        })),
      })),
    }));
  }

  private async loadResponsableList(): Promise<void> {
    let params: UserParamsDto = {
      idsSchool: this.schools.map((s) => s.id),
    };

    await this.userService
      .getEmployees(params)
      .toPromise()
      .then(
        (resp: User[]) => {
          resp.forEach((user) => {
            const item = {
              id: user.id,
              imageUrl: user.photo,
              name: user.firstName + ' ' + user.lastName,
              isChecked: false,
            };
            this.responsableList.push(item);
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  dialogConfig(): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '327px';
    dialogConfig.maxWidth = '327px';
    dialogConfig.panelClass = 'custom-dialog-container';
    return dialogConfig;
  }

  openEditDialog(gate: Gate): void {
    const dialogConfig = this.dialogConfig();
    dialogConfig.data = {
      gate: gate,
      segmentTree: this.segmentTree,
      responsableList: this.responsableList,
    };
    this.dialog.open(GateFormComponent, dialogConfig);
  }

  openCreateDialog(): void {
    const dialogConfig = this.dialogConfig();
    dialogConfig.data = {
      segmentTree: this.segmentTree,
      responsableList: this.responsableList,
    };
    this.dialog.open(GateFormComponent, dialogConfig);
  }

  async delete(gate: Gate): Promise<void> {
    const confirmation = await confirmationBottomSheet(
      this.bottomSheet,
      'Você tem certeza que deseja remover a portaria?',
      'Cancelar',
      'Remover',
      'custom-bottom-sheet-container'
    );
    if (confirmation) {
      this.gateService
        .delete(gate.id)
        .toPromise()
        .then(() => {
          this.snackbar
            .showNotification('A portaria foi removida', 2000)
            .afterDismissed()
            .toPromise()
            .then(() => {
              location.reload();
            });
        })
        .catch((err) => {
          let errMsg = err.error.message
            ? err.error.message
            : 'Erro ao executar operação';
          this.snackbar.showNotification(errMsg, 2000);
        });
    }
  }

  monitoreGate(gateId: string) {
    this.router.navigate(['gates-monitoring', gateId]);
  }
}
